<section *ngIf="this.loader.getLoading()" role="status" aria-live="polite">
     <span *ngIf="translationsReady" class="visually-hidden" translate="unifiedComponents.loading"></span>
     <div class="container h-100 w-100 d-flex align-items-center justify-content-center">
          <div class="d-flex align-items-center" aria-hidden="true">
               <div class="logo-subtitle d-flex align-items-center">
                    <h2 *ngIf="translationsReady" class="mb-0" translate="unifiedComponents.loaderTagline"></h2>
                    <span></span>
               </div>
               <img loading="lazy" src="assets/imgs/EXAB.svg" alt=""/>
          </div>
     </div>
</section>
